module.exports = __webpack_public_path__ + "files/annulering.30b6397b.pdf";